import React from 'react';
import logo from './logo.svg';
import './App.css';
import NovelImageDragInterface from './Game';

function App() {
  return (
    <div className="App">
       <NovelImageDragInterface />
    </div>
  );
}

export default App;
